import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface RetailerUserAuthenticationEventEntityParams {
  distributorId: number;
  step?: string;
  field?: string;
  error?: string;
  authenticationStatus?: string;
}
export class RetailerUserAuthenticationEventEntity extends BaseEntityClass {
  distributorId: number;
  step?: string;
  field?: string;
  error?: string;
  authenticationStatus?: string;
  constructor(params: RetailerUserAuthenticationEventEntityParams) {
    super();
    this.type = "retailer_user_authentication";
    this.entity_version = 2;
    this.distributorId = params.distributorId;
    this.step = params.step;
    this.field = params.field;
    this.error = params.error;
    this.authenticationStatus = params.authenticationStatus;
  }
}
